/**
 * This file is a place for extra actions used by thunks in asyncReducers/chat that don't find into the normal pending/fullfilled flow.
 * They need to be separate to avoid circular references so they can't go into the reducers file. A separate action need to be created
 * which can be processed in reducers in extraReducers/chat.
 */

import { ProgressData } from '@helloself/hello-self-ui';
import { createAction } from '@reduxjs/toolkit';

export const updatePendingMessageWithUploadProgress = createAction<{
    conversationId: string;
    tempMessageId?: string;
    attachmentIndex?: number;
    progress: ProgressData;
}>('expertChat/updatePendingE2EMessageWithUploadProgress');
